export const SAVE_GATES = "SAVE_GATES";
export const SAVE_GATES_SUCCESS = "SAVE_GATES_SUCCESS";
export const SAVE_GATES_FAILURE = "SAVE_GATES_FAILURE";
export const CLEAR_ERROR_SAVING_GATES = "CLEAR_ERROR_SAVING_GATES";
